<h1 matDialogTitle>{{dialogConfig?.dialogTitle}}</h1>

<mat-dialog-content>
    <!-- <div *ngIf="data.dialogText" class="dialog-text">{{data.dialogText}}</div> -->
    <optsol-ngx-dynamic-form *ngIf="formConfig?.formFields" [fields]="formConfig.formFields"
        [initialValue]="formConfig.initialFormValue" [fxLayout]="formConfig.fxLayout"
        [fxLayoutAlign]="formConfig.fxLayoutAlign" [fxLayoutGap]="formConfig.fxLayoutGap">
    </optsol-ngx-dynamic-form>

    <optsol-ngx-scanner [scannerConfig]="scannerConfig" (apiCallInProgress)="apiCallInProgress"></optsol-ngx-scanner>

</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button matDialogClose [disabled]="apiCallInProgress">Close</button>
    <!-- <ng-container *ngIf="data.buttons; else noButtons">
        <button *ngFor="let button of data.buttons" [disabled]="!formValid || apiCallInProgress" mat-raised-button
            [color]="button.color || 'primary'" (click)="submit(button.value)">{{button.buttonText}}</button>
    </ng-container>

    <ng-template #noButtons>
        <button [disabled]="!formValid || apiCallInProgress" mat-raised-button color="primary"
            (click)="submit(null)">OK</button>
    </ng-template> -->
</mat-dialog-actions>